import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';

import { GenericFieldset, IGenericFieldset } from '../generic-fieldset.component';

/**
 * Agency-fieldset
 * Generate a fieldset of needed fields
 * @extends GenericFieldset
 * @implements IGenericFieldset
 */
@Component({

    selector: 'address-fieldset',
    templateUrl: './address-fieldset.component.html',
    styleUrls: ['./address-fieldset.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressFieldsetComponent extends GenericFieldset implements IGenericFieldset {
    /** Readonly context can't be modified. Define the context of the fieldset */
    public readonly context: string = 'agency';

    /** DI - Formbuilder */
    constructor(public fb: FormBuilder) {
        super(fb);
    }

    /**
     * Emit action TOGGLE_SHOW_MAP to parent
     * @param e {Event}
     */
    public showMap(e: Event): void {
        e.preventDefault();
        this.notify.emit({ action: this.actions.TOGGLE_SHOW_MAP });
    }
}
